import { Tag, type TableColumnsType } from 'antd';
import { CatalogueRowActions } from '../../../../../shared/components/CatalogueRowActions';
import type { EscalationLevel } from '../../../reference-data.api';

interface BuildEscalationLevelColumnsArgs {
  onEdit: (row: EscalationLevel) => void;
  onDeactivate: (row: EscalationLevel) => Promise<void>;
  onReactivate: (row: EscalationLevel) => Promise<void>;
}

/** Zero is the deadline day and below zero is overdue, so the number alone reads ambiguously — say which. */
export function describeThreshold(daysThreshold: number): string {
  if (daysThreshold < 0) return `${-daysThreshold} day${daysThreshold === -1 ? '' : 's'} past the deadline`;
  if (daysThreshold === 0) return 'On the deadline day';
  return `${daysThreshold} day${daysThreshold === 1 ? '' : 's'} before the deadline`;
}

export function buildEscalationLevelColumns({ onEdit, onDeactivate, onReactivate }: BuildEscalationLevelColumnsArgs): TableColumnsType<EscalationLevel> {
  return [
    { title: 'Label', dataIndex: 'label', key: 'label' },
    { title: 'Reached', dataIndex: 'daysThreshold', key: 'daysThreshold', render: (daysThreshold: number) => describeThreshold(daysThreshold) },
    {
      title: 'Status',
      dataIndex: 'isActive',
      key: 'isActive',
      render: (isActive: boolean) => <Tag color={isActive ? 'success' : 'default'}>{isActive ? 'Active' : 'Inactive'}</Tag>,
    },
    {
      title: '',
      key: 'actions',
      render: (_, row) => (
        <CatalogueRowActions
          row={{ ...row, name: row.label }}
          onEdit={() => onEdit(row)}
          onDeactivate={() => onDeactivate(row)}
          onReactivate={() => onReactivate(row)}
        />
      ),
    },
  ];
}
